<app-search-bar [filters]="[
{ type: 'text', controlName: 'searchText', placeholder: 'Pesquise por uma Instituição de Ensino' },
]" [showSecondBtn]="false" [showPrimaryBtn]="false"></app-search-bar>

<p-table [value]="instituicoes" [paginator]="true" [rows]="5" [first]="0" [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }" currentPageReportTemplate="{first} à {last} de {totalRecords} registos"
  [rowsPerPageOptions]="[10, 25, 50]" stripedRows>
  <ng-template pTemplate="header">
    <tr>
      <th class="table-center">Nome</th>
      <th class="table-center">Endereço</th>
      <th class="table-center">Telefone</th>
      <th class="table-center">Email</th>
      <th class="table-center">Activo</th>
      <th class="table-center">Tipo de Instituição</th>
      <th class="table-center">País</th>
      <th class="table-center">Província</th>
      <th class="table-center">Município</th>
      <th class="table-center">Acções</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-instituicao>
    <tr>
      <td class="table-center">{{instituicao?.nome}}</td>
      <td class="table-center">{{instituicao?.endereco}}</td>
      <td class="table-center">{{instituicao?.telefone}}</td>
      <td class="table-center">{{instituicao?.email}}</td>
      <td class="table-center">
        <span [ngClass]="{'active-status': instituicao?.isActive, 'inactive-status': !instituicao?.isActive}">
          {{instituicao?.isActive ? 'Sim' : 'Não'}}
        </span>
      </td>
      <td class="table-center">{{instituicao?.tipoInstituicaoEnsino}}</td>
      <td class="table-center">{{instituicao?.pais}}</td>
      <td class="table-center">{{instituicao?.provincia}}</td>
      <td class="table-center">{{instituicao?.municipio}}</td>
      <td class="table-center">
        <p-dropdown appendTo="body" [options]="actionOptions" optionLabel="label" optionValue="value" placeholder="Acções"
          class="w-full md:w-56" appendTo="body" (onChange)="actionSelected($event, instituicao)" />
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>
